import script from "./ChapterData.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChapterData.vue?vue&type=script&setup=true&lang=ts"

import "./ChapterData.vue?vue&type=style&index=0&id=3dc96b0c&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc96b0c"]])

export default __exports__